import { AlarmStatus } from '@core/models/alarm-status.model';
import { Alarm, SearchAlarmResults } from '@core/models/alarm.model';
import { Thresholds } from '@core/models/threshold.model';
import { createAction, props } from '@ngrx/store';

import { AlarmsFilters } from '../models/alarms-filters.model';
import { AlarmsSortBy } from '../models/alarms-sorting.model';

export const init = createAction('[Alarms] Init');

export const selectTab = createAction('[Alarms] Select tab', props<{ tab: AlarmStatus }>());

export const setThresholdsAttributeList = createAction(
  '[Alarms] Set thresholds attribute list',
  props<{ thresholds: Thresholds }>()
);
export const updateAlarmsList = createAction('[Alarms] Update alarms list', props<{ alarms: SearchAlarmResults }>());
export const updateAlarm = createAction('[Alarms] Update alarm', props<{ alarm: Alarm }>());

export const updateFilters = createAction('[Alarms] Update filters', props<{ filters: AlarmsFilters }>());
export const updateSortBy = createAction('[Alarms] Update sort by', props<{ sortBy: AlarmsSortBy }>());

export const updateSelectedAlarm = createAction('[Alarms] Update selected alarm', props<{ selectedAlarm: Alarm }>());
export const switchAlarmsStatus = createAction('[Alarms] Switch alarms status', props<{ newStatus: AlarmStatus }>());
export const addAlarmComment = createAction('[Alarms] Add comment', props<{ alarm: Alarm; comment: string }>());

export const nextPage = createAction('[Alarms] Next page');
export const previousPage = createAction('[Alarms] Previous page');

export const checkCurrentPage = createAction('[Alarms] Check current page');
export const checkAll = createAction('[Alarms] Check all');
export const uncheckAll = createAction('[Alarms] Uncheck all');
